import '../../../styles/templates/account.pcss';

import {Toggle} from '../../ui/toggle';

const accountNavToggle = document.querySelector(
  '[data-account-nav-toggle]'
);

if (accountNavToggle) {
  new Toggle(accountNavToggle);
}
